import { ReactElement } from 'react';
import ReactModal, { Styles } from 'react-modal';
import { EventSingle } from '../../_types/event';
import UpComingMatches from '../UpComingMatches';

type UpcomingMatchesModalProps = {
    isOpen: boolean;
    onRequestClose: () => void;
    events: EventSingle[] | null;
};

export function UpcomingMatchesModal({ isOpen, onRequestClose, events }: UpcomingMatchesModalProps): ReactElement {
    return (
        <ReactModal
            isOpen={isOpen}
            contentLabel="Upcoming Games"
            ariaHideApp={false}
            style={modalStyles as Styles}
            shouldCloseOnOverlayClick={true}
            shouldCloseOnEsc
            onRequestClose={onRequestClose}
            className={'okta-login okta-login-modal'}
        >
            <div className="bg-white rounded-lg max-w-3xl w-full mx-auto relative">
                <div className="px-4 pt-4 border-b flex align-items-center" style={modalStyles.header}>
                    <h2 className="text-xl font-bold">Upcoming Games</h2>
                </div>
                <div style={modalStyles.modalWrapper}>
                    <UpComingMatches events={events} isModal />
                </div>
            </div>
        </ReactModal>
    );
}

const modalStyles = {
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    overlay: {
        backgroundColor: 'rgba(0,0,0,.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2,
        padding: '1rem',
    },
    content: {
        position: 'relative',
        padding: 0,
        border: 'none',
        background: 'none',
        overflow: 'visible',
    },
    modalWrapper: {
        maxHeight: '70vh',
        overflow: 'auto',
    },
};
